export const ALL_SEGMENTS_KEY = 'allSegments';
